import React from 'react';
import {OverlayTrigger, Tooltip} from 'react-bootstrap';

const tooltip = (
    <Tooltip id="tooltip">
        {window.__js_bid_reviews.reviewer_role_tooltip}
    </Tooltip>
);

const BidsAlwaysEnabledWarning = ({show}) => {
    if (!show) {
        return null;
    }

    return (
        <div className="text-warning" style={{
            marginLeft: '5px',
            display: 'inline-block',
            fontSize: '25px'
        }}>
            <OverlayTrigger placement="top" overlay={tooltip}>
                <i className="fa fa-fw fa-question-circle"></i>
            </OverlayTrigger>
        </div>
    );
}

export default BidsAlwaysEnabledWarning;